import http from './http'

// 分页查询教师列表
export async function getTeacherList(params) {
    const res = await http.get('/user/info/list', { params })
    return res.data
}

// 根据ID查询教师详细信息
export async function getTeacherById(id) {
    const res = await http.get(`/user/info/${id}`)
    return res.data
}

// 更新教师信息
export async function updateTeacherInfo(data) {
    const res = await http.put('/user/info', data)
    return res.data
}

// 分页查询信息反馈列表
export async function getFeedbackList(params) {
    const res = await http.get('/feedback/page', { params })
    return res.data
}

// 根据ID查询反馈详情
export async function getFeedbackById(id) {
    const res = await http.get(`/feedback/${id}`)
    return res.data
}

// 更新反馈处理状态
export async function updateFeedbackStatus(id, processStatus) {
    const res = await http.put(`/feedback/${id}/status`, null, {
        params: { processStatus }
    })
    return res.data
}
